import { useContext } from "react";
import { IContextValueProvider } from "sonobello.utilities.react";

import { SessionContext, SessionContextProps } from "../../../Context/SessionContext";

/**
 * An {@link IContextValueProvider} which obtains its properties from the {@link SessionContext}.
 * @typeParam TFulfilledProps - The type which is returned by the context mapping.
 * @typeParam TComponent - The type which encompasses the values fulfilled by the provider.
 */
function SessionContextValueProvider<TFulfilledProps, TComponent extends TFulfilledProps>({
  Component,
  map
}: IContextValueProvider<SessionContextProps, TFulfilledProps, TComponent>): React.FC<
  Omit<TComponent, keyof TFulfilledProps>
> {
  return componentProps => {
    const contextProps = useContext(SessionContext);
    return Component({ ...componentProps, ...map(contextProps) } as TComponent);
  };
}

export default SessionContextValueProvider;
